import { z } from "zod";
import { isString } from "@/common/helpers/lang";

import {
  hubSpotClientContextSchema,
  hubSpotClientContextSchemaDefaultValues,
} from "@/services/hub-spot/hub-spot-client-context";
import type { TFunction } from "@/services/i18n/types";

export const contactFormSchema = (t: TFunction<"pages.hrano.models.contact_form">) =>
  z.object({
    name: z.string().min(1, t("name.required")),
    lastName: z.string().min(1, t("lastName.required")),
    email: z.email(t("email.invalid")),
    phone: z.custom<string>((val) => (isString(val) ? /^\+?\d{7,15}$/.test(val) : false), {
      message: t("phone.invalid"),
    }),
    company: z.string().min(1, t("company.required")),
    employees: z.coerce.number().int(t("employees.invalid")).positive(t("employees.invalid")),
    terms: z.boolean().refine((data) => data, {
      message: t("terms.required"),
    }),
    privacy: z.boolean().refine((data) => data, {
      message: t("privacy.required"),
    }),
    context: hubSpotClientContextSchema,
  });

export type ContactFormValues = z.infer<ReturnType<typeof contactFormSchema>>;

export const contactFormDefaultValues: ContactFormValues = {
  name: "",
  lastName: "",
  email: "",
  phone: "",
  company: "",
  employees: 0,
  terms: false,
  privacy: false,
  context: hubSpotClientContextSchemaDefaultValues,
};
